export default __webpack_public_path__ + "static/media/chasingenglish-mobile.c82ffd21.png";